import LoginView from "@/views/Login";
import ResetPasswordView from "@/views/Login/ResetPassword";

import AppView from "@/views/App";

/* prettier-ignore */
const HomeView = () =>              import(/* webpackChunkName: "chunk_app_home_view" */ "@/views/App/Home");
/* prettier-ignore */
const DeviceStatusView = () =>      import(/* webpackChunkName: "chunk_app_device_status" */ "@/views/App/ServiceAndUpdates/DeviceStatus");
/* prettier-ignore */
const DownloadLogsView = () =>      import(/* webpackChunkName: "chunk_app_download_logs" */ "@/views/App/ServiceAndUpdates/DownloadLogs");
/* prettier-ignore */
const UpdatesManagementView = () =>      import(/* webpackChunkName: "chunk_app_updates_management" */ "@/views/App/ServiceAndUpdates/UpdatesManagement");
/* prettier-ignore */
const ScheduleConfigurationView = () =>      import(/* webpackChunkName: "chunk_app_schedule_settings" */ "@/views/App/ServiceAndUpdates/ScheduleConfiguration");
/* prettier-ignore */
const PreventiveMaintenanceView = () =>      import(/* webpackChunkName: "chunk_app_preventive_maintenance" */ "@/views/App/PredictiveMaintenance/PreventiveMaintenance");
/* prettier-ignore */
const PredictiveMaintenanceView = () =>      import(/* webpackChunkName: "chunk_app_predictive_maintenance" */ "@/views/App/PredictiveMaintenance/PredictiveMaintenance");
/* prettier-ignore */
const LogAnalysisView = () =>      import(/* webpackChunkName: "chunk_app_log_analysis" */ "@/views/App/PredictiveMaintenance/LogAnalysis");
/* prettier-ignore */
const InfoView = () =>              import(/* webpackChunkName: "chunk_app_info_view" */ "@/views/App/Tools/Info");
/* prettier-ignore */
const OptionsView = () =>           import(/* webpackChunkName: "chunk_app_options_view" */ "@/views/App/Tools/Options");
/* prettier-ignore */
const UserManagement = () =>        import(/* webpackChunkName: "chunk_app_user_management_view" */ "@/views/App/Tools/UserManagement");
/* prettier-ignore */
const DashboardView = () =>         import(/* webpackChunkName: "chunk_app_dashboard_view" */ "@/views/App/Dashboard/");
/* prettier-ignore */
const ManageDashboardView = () =>   import(/* webpackChunkName: "chunk_app_manage_dashboard_view" */ "@/views/App/Dashboard/ManageDashboard");
/* prettier-ignore */
const CashReportView = () =>        import(/* webpackChunkName: "chunk_app_cash_report_view" */ "@/views/App/CashFlow/CashReport");
/* prettier-ignore */
const CashContentView = () =>       import(/* webpackChunkName: "chunk_app_cash_content_view" */ "@/views/App/CashFlow/DeviceContent");
/* prettier-ignore */
const CashWorkloadView = () =>       import(/* webpackChunkName: "chunk_app_cash_cash_workload_view" */ "@/views/App/CashFlow/Workload");
/* prettier-ignore */
const BranchReportView = () =>       import(/* webpackChunkName: "chunk_app_branch_report_view" */ "@/views/App/CashFlow/BranchReport");
/* prettier-ignore */
const UsersBalanceView = () =>       import(/* webpackChunkName: "chunk_app_users_balance__report_view" */ "@/views/App/CashFlow/UsersBalance");
/* prettier-ignore */
const ChannelsBalanceView = () =>       import(/* webpackChunkName: "chunk_app_channels_balance__report_view" */ "@/views/App/CashFlow/ChannelsBalance");
/* prettier-ignore */
const BagsCashReportView = () =>       import(/* webpackChunkName: "chunk_app_bags_cash_report_view" */ "@/views/App/CashFlow/BagsCashReport");
/* prettier-ignore */
const DebugView = () =>             import(/* webpackChunkName: "chunk_app_debug_view" */ "@/views/App/Tools/Debug");
/* prettier-ignore */
const InstallationDetails = () => import(/* webpackChunkName: "chunk_app_installation_details_view" */ "@/views/App/Tools/InstallationDetails");
/* prettier-ignore */
const UserPreferencesView = () =>   import(/* webpackChunkName: "chunk_app_user_preferences_view" */ "@/views/App/Tools/UserPreferences");
/* prettier-ignore */
const UpdatePackagesView = () =>   import(/* webpackChunkName: "chunk_app_update_packages_view" */ "@/views/App/ServiceAndUpdates/UpdatePackages");
/* prettier-ignore */
const StatisticsReportView = () =>   import(/* webpackChunkName: "chunk_app_statistics_report_view" */ "@/views/App/FitnessStatistics/StatisticsReport");
/* prettier-ignore */
const EcrCodesView = () =>   import(/* webpackChunkName: "chunk_app_ecr_codes_view" */ "@/views/App/FitnessStatistics/EcrCodes");
/* prettier-ignore */
const LicensesManagementView = () =>   import(/* webpackChunkName: "chunk_app_licenses_management_view" */ "@/views/App/Tools/LicensesManagement");
/* prettier-ignore */
const OrganizationsManagementView = () =>   import(/* webpackChunkName: "chunk_app_organizations_management_view" */ "@/views/App/Tools/OrganizationsManagement");
/* prettier-ignore */
const OrganizationsLicensesView = () =>   import(/* webpackChunkName: "chunk_app_organizations_licenses_view" */ "@/views/App/Tools/OrganizationsLicenses");
/* prettier-ignore */
const BranchesManagementView = () =>   import(/* webpackChunkName: "chunk_app_branches_management_view" */ "@/views/App/Tools/BranchesManagement");
/* prettier-ignore */
const NetworkMetricsView = () => import(/* webpackChunkName: "chunk_app_network_metrics_view" */ "@/views/App/Tools/NetworkMetrics");
/* prettier-ignore */
const SecurityManagementView = () => import(/* webpackChunkName: "chunk_app_security_management_view" */ "@/views/App/SecurityAndConfiguration/SecurityManagement");
/* prettier-ignore */
const StocksConfigView = () => import(/* webpackChunkName: "chunk_app_stocks_config_view" */ "@/views/App/SecurityAndConfiguration/StocksConfiguration");
/* prettier-ignore */
const CaosTemplateView = () => import(/* webpackChunkName: "chunk_app_caos_template_view" */ "@/views/App/SecurityAndConfiguration/CaosConfigurationTemplate");
/* prettier-ignore */
const CaosConfigurationView = () => import(/* webpackChunkName: "chunk_app_caos_configuration_view" */ "@/views/App/SecurityAndConfiguration/CaosConfiguration");
/* prettier-ignore */
const ReferenceConfigView = () => import(/* webpackChunkName: "chunk_app_reference_config_view" */ "@/views/App/SecurityAndConfiguration/ReferenceConfiguration");
/* prettier-ignore */
const CaosUserSyncView = () => import(/* webpackChunkName: "chunk_app_reference_config_view" */ "@/views/App/SecurityAndConfiguration/CaosUserSync")
/* prettier-ignore */
const RemoteLinkView = () => import(/* webpackChunkName: "chunk_app_remote_link_view" */ "@/views/App/RemoteLink/RemoteLink")
/* prettier-ignore */
const UserEventsView = () => import(/* webpackChunkName: "chunk_app_user_events_view" */ "@/views/App/Tools/UserEvents")
/* prettier-ignore */
const PlatformMaintenanceView = () => import(/* webpackChunkName: "chunk_app_platform_maintenance_view" */ "@/views/App/Tools/PlatformMaintenance")
/* prettier-ignore */
const SmartLockView = () => import(/* webpackChunkName: "chunk_app_smart_safe_view" */ "@/views/App/OneTimeCode/SmartLock")
/* prettier-ignore */
const OnBoardingView = () => import(/* webpackChunkName: "chunk_app_onboarding_view" */ "@/views/App/Tools/OnBoarding")
/* prettier-ignore */
const DataFlowManagementView = () => import(/* webpackChunkName: "chunk_app_dataflow_management_view" */ "@/views/App/Tools/DataFlowManagement")

import { checkIsAuth, checkIsNotAuth } from "./authGuard";
import * as routes from "./routes";

const routesConfig = [
    {
        path: "*",
        redirect: routes.Root,
    },
    {
        path: routes.Login,
        name: "Sign in",
        component: LoginView,
        beforeEnter: checkIsNotAuth,
    },
    {
        path: routes.ResetPassword,
        name: "Reset password",
        component: ResetPasswordView,
    },
    {
        path: routes.Root,
        component: AppView,
        children: [
            {
                path: routes.Root,
                name: "Home",
                component: HomeView,
            },
            {
                path: routes.SingleDashboard,
                name: "Dashboard",
                component: DashboardView,
            },
            {
                path: routes.ManageDashboard,
                name: "Manage Dashboard",
                component: ManageDashboardView,
            },
            {
                path: routes.DeviceStatus,
                name: "Device Status",
                component: DeviceStatusView,
            },
            {
                path: routes.DownloadLogs,
                name: "Download Logs",
                component: DownloadLogsView,
            },
            {
                path: routes.UpdatesManagement,
                name: "Updates Management",
                component: UpdatesManagementView,
            },
            {
                path: routes.UpdatePackages,
                name: "Update Packages",
                component: UpdatePackagesView,
            },
            {
                path: routes.ScheduleConfigurations,
                name: "Schedule Configuration",
                component: ScheduleConfigurationView,
            },
            {
                path: routes.RemoteLink,
                name: "Remote Link",
                component: RemoteLinkView,
            },
            {
                path: routes.SmartLock,
                name: "Smart Lock",
                component: SmartLockView,
            },
            {
                path: routes.PreventiveMaintenance,
                name: "Preventive Maintenance",
                component: PreventiveMaintenanceView,
            },
            {
                path: routes.PredictiveMaintenance,
                name: "Predictive Maintenance",
                component: PredictiveMaintenanceView,
            },
            {
                path: routes.LogAnalysis,
                name: "Log Analysis",
                component: LogAnalysisView,
            },
            {
                path: routes.CashReport,
                name: "Cash Report",
                component: CashReportView,
            },
            {
                path: routes.CashContent,
                name: "Device Content",
                component: CashContentView,
            },
            {
                path: routes.CashWorkload,
                name: "Workload Report",
                component: CashWorkloadView,
            },
            {
                path: routes.BranchReport,
                name: "Front/Back Office",
                component: BranchReportView,
            },
            {
                path: routes.UsersBalance,
                name: "Users Balance",
                component: UsersBalanceView,
            },
            {
                path: routes.ChannelsBalance,
                name: "Channels Balance",
                component: ChannelsBalanceView,
            },
            {
                path: routes.BagsCashReport,
                name: "Bag Deposits Report",
                component: BagsCashReportView,
            },
            {
                path: routes.SecurityConfig,
                name: "Security Management",
                component: SecurityManagementView,
            },
            {
                path: routes.StocksConfig,
                name: "Stocks Configuration",
                component: StocksConfigView,
            },
            {
                path: routes.ReferenceConfig,
                name: "Configuration Templates",
                component: ReferenceConfigView,
            },
            {
                path: routes.StatisticsReport,
                name: "Fitness Statistics Report",
                component: StatisticsReportView,
            },
            {
                path: routes.EcrCodes,
                name: "ECR Codes",
                component: EcrCodesView,
            },
            {
                path: routes.LicensesManagement,
                name: "Licenses Management",
                component: LicensesManagementView,
            },
            {
                path: routes.OrganizationsManagement,
                name: "Organizations Management",
                component: OrganizationsManagementView,
            },
            {
                path: routes.OrganizationsLicenses,
                name: "Organizations Licenses",
                component: OrganizationsLicensesView,
            },
            {
                path: routes.BranchesManagement,
                name: "Branches Management",
                component: BranchesManagementView,
            },
            {
                path: routes.CaosUserSync,
                name: "Caos User Sync",
                component: CaosUserSyncView,
            },
            {
                path: routes.CaosTemplate,
                name: "Caos Template",
                component: CaosTemplateView,
            },
            {
                path: routes.CaosConfig,
                name: "Caos Configuration",
                component: CaosConfigurationView,
            },
            {
                path: routes.UserManagement,
                name: "User Management",
                component: UserManagement,
            },
            {
                path: routes.NetworkMetrics,
                name: "Network Metrics",
                component: NetworkMetricsView,
            },
            {
                path: routes.UserEvents,
                name: "User Activities",
                component: UserEventsView,
            },
            {
                path: routes.PlatformMaintenance,
                name: "Platform Maintenance",
                component: PlatformMaintenanceView,
            },
            {
                path: routes.Options,
                name: "Options",
                component: OptionsView,
            },
            {
                path: routes.OnBoarding,
                name: "On boarding",
                component: OnBoardingView,
            },
            {
                path: routes.DataFlowManagement,
                name: "DataFlow Management",
                component: DataFlowManagementView,
            },
            {
                path: routes.Information,
                name: "Information",
                component: InfoView,
            },
            {
                path: routes.Debug,
                name: "Debug",
                component: DebugView,
            },
            {
                path: routes.InstallationDetails,
                name: "Installation Details",
                component: InstallationDetails,
            },
            {
                path: routes.UserPreferences,
                name: "User Preferences",
                component: UserPreferencesView,
            },
        ],
        beforeEnter: checkIsAuth,
    },
];

export default routesConfig;
